<template>
  <v-app :class="{ 'overflow-hidden': isMobile }">
    <Async :loading="loading">
      <template v-if="isLogin">
        <v-app-bar
          app
          class="app_bar_custom_shadow"
          height="60"
          color="#131313"
          clipped-left
          width="calc( 100% - 255px )"
          style="border-bottom: 1px solid #353537 !important"
        >
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>

          <v-spacer v-if="currentPage.name == 'update-account'"></v-spacer>
          <AccountStepper v-if="currentPage.name == 'update-account'" />
          <v-spacer></v-spacer>
          <ExhibitionTool
            :expoData="expoData"
            v-if="currentPage.name == 'exhibitions-space'"
          />
          <!-- <UserInfoMeun /> -->
        </v-app-bar>
        <SideDrawer v-if="!noDrawer" width="255" @reload="reload" />
        <v-slide-x-transition>
          <v-btn
            v-if="!$store.getters['app/getIsDrawerOpen']"
            @click="$store.commit('app/setIsDrawerOpen', true)"
            :style="{ top: `${$vuetify.application.top + 4}px` }"
            class="expand_btn"
            color="primary"
            width="24"
            small
            dark
          >
            <v-icon size="18">mdi-menu</v-icon>
          </v-btn>
        </v-slide-x-transition>
        <v-main>
          <v-container>
            <router-view v-if="isRouterAlive" />
          </v-container>
        </v-main>
      </template>
      <template v-else>
        <Login />
      </template>
      <MobileBan v-if="isMobile" />
    </Async>
    <Loading v-show="indexLoad" />
    <Modal />
  </v-app>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/mobile-detect/1.4.5/mobile-detect.min.js"></script>
<script>
import { mapGetters } from 'vuex';
import UserInfoMeun from '@/components/UserInfoMeun';
import { theme } from './plugins/color';
import ExhibitionTool from '@/components/exhibitions/ExhibitionTool.vue';
import SideDrawer from '@/components/layout-comps/dashboardDrawer/index.vue';
import Login from '@/page/Login.vue';
import Modal from '@/components/Modal.vue';
import MobileBan from '@/components/MobileBan.vue';
import AccountStepper from '@/components/plans/AccountStepper.vue';
import Loading from '@/components/Globals/Loading.vue';
export default {
  name: 'App',
  components: {
    SideDrawer,
    Login,
    UserInfoMeun,
    Modal,
    MobileBan,
    ExhibitionTool,
    AccountStepper,
    Loading
  },

  data: () => ({
    loading: true,
    isMobile: true,
    currentPage: { name: null },
    isRouterAlive: true,
    indexLoad: true
  }),

  computed: {
    ...mapGetters({
      getIncludedRoute: 'app/getIncludedRoute',
      tempBreadcrumbs: 'app/getTempBreadcrumbs',
      logStatus: 'auth/getLogStatus'
    }),
    noDrawer() {
      return this.$store.getters['app/getCurrentRoute'].noDrawer;
    },
    isLogin() {
      return this.logStatus === 'login';
    },
    includedRoute: {
      immediate: true,
      get() {
        return this.getIncludedRoute(this.$route.name).filter(
          (el) => !!el.name
        );
      }
    },
    breadcrumbs() {
      const vm = this;
      return [...this.includedRoute, ...this.tempBreadcrumbs].map(
        (el, i, arr) => ({
          text: el.text == 'space' ? vm.expoData.name : this.$t(el.i18nKey),
          key: el.i18nKey,
          exact: true,
          disabled: !(i + 1 < arr.length),
          to: {
            name: el.name,
            params: el.params,
            query: el.query
          }
        })
      );
    },
    expoData() {
      return this.$store.state.space.current_space;
    }
  },

  watch: {
    $route: {
      handler(route) {
        this.$store.dispatch('app/FETCH_INCLUDE_ROUTES', route);
        this.currentPage = route;
        this.authValidation()
      }
    },
    isLogin(v) {
      this.cleanQuery(v);
    },
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
      });
    }
  },
  async created() {
    this.$store.dispatch('app/FETCH_INCLUDE_ROUTES', this.$route);
    let root = document.documentElement;
    Object.keys(theme.dark).forEach((key) => {
      root.style.setProperty(`--color-${key}`, theme.dark[key]);
    });
    this.loading = false;
  },
  async mounted() {
    await this.$nextTick();
    // this.indexLoad = false;
  },
  methods: {
    cleanQuery(v) {
      if (v) {
        const query = this.$router.resolve(location.href).route.query;
        const { action, username, code, auth } = query;
        if (action || username || code || auth) {
          this.$nextTick(() => {
            this.$router.replace(this.$route.path);
          });
        }
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    async authValidation() {
      const { at, rt, action } = this.$route.query;
      if (action && action === 'validated') {
        if (at) {
          this.setLogin({ 
            access_token: at,
            refresh_token: rt
            })
        }
        this.$router.push({name:'exhibitions'})
      } else {
        const isValidated = localStorage.getItem('authValidation');
        const authInfo = localStorage.getItem('at');
        const logStatus = this.$store.state.auth.logStatus;
        if (!isValidated && logStatus === 'init') {
          if (!authInfo) {
            // A:重新導向到SSO
            this.redirectToSSO();
            return;
          } else {
            // B:驗證是否為有效Token
            const isLogin = await this.$store.dispatch('auth/CHECK_LOGIN_STATUS');
            if (isLogin) {
              await this.$store.dispatch('auth/FETCH_TEAMS');
            } else {
              this.redirectToSSO();
              return;
            }
          }
        } else if (isValidated) {
          // C:驗證完畢=>設置登入狀態
          localStorage.removeItem('authValidation')
        }
        this.indexLoad = false;
      }
    },
    redirectToSSO() {
      localStorage.setItem('authValidation', 'true');
      const env = process.env.NODE_ENV;
      const baseUrl = location?.origin || process.env.VUE_APP_BASE_URL;
      const ssoUrl = process.env.VUE_APP_SSO_URL;
      const queryStr = JSON.stringify(this.$route.query);
      const query = queryStr === '{}' ? '' : `&query=${queryStr}`;
      const url = `${ssoUrl}?action=authValidation&redirectURI=${baseUrl}${this.$route.path}${query}`;
      location.assign(url);
    },
    setLogin({ user, access_token, refresh_token }) {
      const dispatch = this.$store.dispatch;
      const commit = this.$store.commit;

      commit('auth/setLogStatus', 'login');
      commit('auth/setUser', user);
      dispatch('auth/SET_ACCESS_TOKENS', {
        at: access_token,
        rt: refresh_token
      });
      dispatch('auth/FETCH_TEAMS');
    },
  }
};
</script>

<style lang="scss" scoped>
@import './scss/breadcrumbs.scss';
.expand_btn {
  position: fixed;
  left: 0;
  z-index: 99;
  min-width: auto !important;
}

.app_bar_custom_shadow {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1) !important;
  left: 255px !important;
}
.overflow-hidden {
  @media screen and (max-width: 768px) {
    overflow: hidden;
  }
}
:deep(.v-toolbar__content) {
  padding-left: 0;
  padding-right: 0;
}
</style>
